// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3m_Eq","calendarButtons":"ClockData_calendarButtons__nWVeR"};